<div class="button-selection-content-wrapper">
  <span *ngIf="title" class="title">{{ title }}</span>
  <span class="currentSelectionValue">{{ currentSelection.value }}</span>
</div>
